import React from 'react'
import { Link } from 'react-router-dom'
import { mainModules, TMainCodes } from '../../../components/generic/artcoded/modulesList'
import { useNavMenu } from '../hooks/useNavMenu'
import NavItem, { ModuleEntry } from './NavItem'
import { getModuleIcon, TestIcon } from './navIcons'
import {
  Flyout,
  FlyoutTitle,
  Ico,
  Lbl,
  NavItemRoot,
  NavLink,
  NavList,
} from './styles'

interface Props {
  modules: ModuleEntry[]
  pathname: string
  collapsed?: boolean
  showTestLink?: boolean
  onCloseMenu?: () => void
  onExpand?: () => void
}

const NavMenu: React.FC<Props> = ({
  modules,
  pathname,
  collapsed = false,
  showTestLink = false,
  onCloseMenu,
  onExpand,
}) => {
  const { isOpen, toggle, handleSubItemSideEffect } = useNavMenu()

  const handleExpandIntercept = (e: React.MouseEvent) => {
    if (collapsed && onExpand) {
      e.preventDefault()
      onExpand()
    }
  }

  return (
    <NavList>
      {modules?.map((module) => {
        const data = mainModules(module.ModuleId as TMainCodes)
        if (!data) return null
        const isLocationHere = !!(
          pathname?.includes(data.link) ||
          pathname?.split('/')[2]?.includes(data.link.split('/')[2])
        )
        return (
          <NavItem
            key={module.ModuleId}
            module={module}
            data={data}
            icon={getModuleIcon(module.ModuleId)}
            pathname={pathname}
            isLocationHere={isLocationHere}
            isOpen={isOpen(module.ModuleId)}
            collapsed={collapsed}
            onToggle={() => toggle(module.ModuleId)}
            onSubItemSideEffect={handleSubItemSideEffect}
            onCloseMenu={onCloseMenu}
            onExpand={onExpand}
          />
        )
      })}
      {showTestLink && (
        <NavItemRoot $collapsed={collapsed}>
          <NavLink
            as={Link}
            to='/main/test'
            onClick={(e: React.MouseEvent) => {
              if (collapsed && onExpand) {
                handleExpandIntercept(e)
                return
              }
              onCloseMenu?.()
            }}
            $collapsed={collapsed}
            aria-label={collapsed ? 'test' : undefined}
          >
            <Ico><TestIcon /></Ico>
            {!collapsed && <Lbl>test</Lbl>}
          </NavLink>
          {collapsed && (
            <Flyout $tip>
              <FlyoutTitle>test</FlyoutTitle>
            </Flyout>
          )}
        </NavItemRoot>
      )}
    </NavList>
  )
}

export default NavMenu
